'use client'

import { cn } from '@/core/lib/utils/cn'
import { Slider } from '@/core/ui/atoms/slider'
import { useEffect, useState } from 'react'
import { ProductDetails } from '../../model/product.model'
import { RemoteImage } from '@/core/ui/atoms/remote-image'
import { useSelectedVariant } from '../../store/use-selected-variant'
import { ImageResponse } from '@/core/types/api/image-response'
import { Skeleton } from '@heroui/react'

type Props = { product: ProductDetails }

export function ItemSlider({ product }: Props) {
  const { selectedVariant } = useSelectedVariant()

  const images = selectedVariant?.media?.length
    ? selectedVariant.media
    : product.media

  const [clickedImage, setClickedImage] = useState<ImageResponse | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setClickedImage(null)
  }, [selectedVariant])
  const mainImage =
    clickedImage ??
    (selectedVariant?.media?.length ? selectedVariant.media[0] : product.cover)

  useEffect(() => {
    if (!selectedVariant?.media) return

    selectedVariant.media.forEach(img => {
      const image = new Image()
      image.src = img.original_url
    })
  }, [selectedVariant])
  useEffect(() => {
    if (!mainImage) return
    setIsLoading(true)
  }, [mainImage])
  return (
    <div>
      <div className='relative h-[200px] w-full overflow-hidden rounded-lg shadow-md sm:h-[422px]'>
        {isLoading && (
          <Skeleton className='absolute inset-0 animate-pulse bg-gray-200'></Skeleton>
        )}
        <RemoteImage
          key={mainImage?.id}
          src={mainImage?.original_url}
          alt='Product main image'
          fill
          className='object-fill transition-opacity duration-200'
          sizes='(max-width: 640px) 100vw, 50vw'
          onLoad={() => setIsLoading(false)}
          priority
        />
      </div>
      {images.length > 1 && (
        <div className='mt-4'>
          <Slider
            slides={images.map((img, idx) => (
              <button
                type='button'
                key={img.id}
                onClick={() => setClickedImage(img)}
                className={cn(
                  'relative h-[65px] w-full cursor-pointer overflow-hidden rounded-md border-2 transition sm:h-[140px]',
                  mainImage?.id === img.id
                    ? 'border-creamed-cron'
                    : 'border-transparent',
                )}
              >
                <RemoteImage
                  src={img.preview_url || img.original_url}
                  alt={`Thumbnail ${idx}`}
                  fill
                  sizes='120px'
                  className='object-fill'
                />
              </button>
            ))}
            slidesPerView={3}
            showDots={false}
            showArrows={false}
            delay={4000}
            className='sm:px-1'
          />
        </div>
      )}
    </div>
  )
}
